import React from 'react';
import NimbusModal from '../../../fragments/NimbusModal';

const EliminarCategoriaNotificacionModal = ({
  openModal,
  setOpenModal,
  handleSubmit,
  categoriaNotificacion,
}) => {
  return (
    <NimbusModal
      isOpen={openModal}
      variant="danger"
      title="Eliminar categoría de notificación"
      onRequestClose={() => setOpenModal(false)}
      onCancel={() => setOpenModal(false)}
      onConfirm={handleSubmit}
    >
      <div className='w-96 px-4 text-center'>
        <p>
          Al eliminar la categoría de notificación, todas las notificaciones
          asociadas a esta categoría serán asignadas a la categoría general.
          ¿Está seguro de que desea eliminar la categoría "
          <b>{categoriaNotificacion.nombre}</b>"?
        </p>
      </div>
    </NimbusModal>
  );
};

export default EliminarCategoriaNotificacionModal;
